import { getGenericDocumentData } from '@zurich/api/document';
import { useApi, useDownloadLink, useTranslation } from '@zurich/common/hooks';
// TODO: this should only handle the request and another hook called useGetGenericDocumentDownload or similar
// should introduce the extra handling
export const useGetGenericDocument = () => {
    const { t } = useTranslation();
    const { setDownloadData } = useDownloadLink();
    const { fetch } = useApi({
        request: getGenericDocumentData,
        options: {
            errorText: t('document.errors.downloadDocument'),
        },
    });
    const handleFetch = async (documentId, fileId, filename) => {
        const response = await fetch({
            params: {
                vars: { documentId, fileId },
            },
            onSuccess: (res) => {
                const reader = new FileReader();
                reader.readAsDataURL(res);
                reader.onloadend = () => {
                    const data = reader.result;
                    if (res && data && typeof data === 'string') {
                        setDownloadData({ data, filename }, { mimeType: res.type, addHead: false, openNewTab: true });
                    }
                };
            },
        });
        return response;
    };
    return handleFetch;
};
